import { ValidationTypes, ValidationArguments } from "class-validator";

import errorMessagesBr from "./errorMessages.br";
import errorMessagesEn from "./errorMessages.en";
import errorMessagesEs from "./errorMessages.es";

let errorLocale = "br";

export function getErrorMessages() {
	switch (errorLocale) {
	case "br":
		return errorMessagesBr;
	case "en":
		return errorMessagesEn;
	case "es":
		return errorMessagesEs;
	default:
		return errorMessagesBr;
	}
}

// O class-validator ainda não suporta tradução dos erros. Este patch substitui as mensagens de acordo com o idioma. Caso não haja no dicionário, é enviada a mensagem padrão.
export function patchClassValidatorI18n(locale: string = "br") {
	errorLocale = locale;

	const getOriginalMessage = ValidationTypes.getMessage.bind(ValidationTypes);
	const errorMessages = getErrorMessages();

	ValidationTypes.getMessage = (type: string, isEach: boolean): string | ((args: ValidationArguments) => string) => errorMessages[type] || getOriginalMessage(type, isEach);
}
